// extracted by mini-css-extract-plugin
export default {"locationForm":"add-location_locationForm__0pGzv","btnContainer":"add-location_btnContainer__R+Qxc"};